// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nt9DHZ81wZA0R8 {
  position: relative;
  min-width: 500px;
  max-width: 880px;
  margin: auto;
  border-radius: 12px;
  background-color: var(--ds-surface, #ffffff);
}
.f_CkElbRxKZhIf {
  display: block;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.PBqAGGlUouWEoy {
  padding: 32px 48px 40px 48px;
  text-align: center;
}
.IlC4XpA2R0uOpF {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  column-gap: 8px;
}
.frur8GECuaLWGg {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #ffffff;
}
.frur8GECuaLWGg:hover,
.frur8GECuaLWGg:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gaWelcomeModal": `Nt9DHZ81wZA0R8`,
	"headingImage": `f_CkElbRxKZhIf`,
	"contentContainer": `PBqAGGlUouWEoy`,
	"ctasContainer": `IlC4XpA2R0uOpF`,
	"closeButton": `frur8GECuaLWGg`
};
export default ___CSS_LOADER_EXPORT___;
